import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'message-popup',
  templateUrl: './message-popup.component.html',
  styleUrls: ['./message-popup.component.scss'],
})
export class MessagePopupComponent implements OnInit {

  @Output()
  public closeEvent = new  EventEmitter<string>();
  @Input()
  public message: string = '';
  constructor() { }

  ngOnInit() {}
  public closePopupHandle(): void
  {
    this.closeEvent.emit('CLOSE');
  }
}
